import(/* webpackMode: "eager" */ "/home/runner/work/yegnaweb/yegnaweb/src/app/not-found.js")